import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

// app
import { enqueueNotification } from 'stores';
import * as utils from 'utils';

import { quoteBindAxios } from '../quoteBind.api';

// risks
export const useUpdatePostQuoteOptions = () => {
  const dispatch = useDispatch();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.risks.useUpdatePostQuoteOptions',
    };

    dispatch(enqueueNotification('notification.generic.request', 'error'));

    utils.api.handleError(err, errorParams);
  };

  return useMutation(
    async (params) => {
      const { type, postQuoteOptions, id } = params;

      const url = type === 'QUOTE' ? `quotes/${id}/updatePostQuoteOptions` : `endorsements/${id}/updatePostQuoteOptions`;

      const response = await quoteBindAxios.put(url, postQuoteOptions);

      return response.data;
    },
    {
      onError: (err) => handleError(err),
    }
  );
};
